const removeExtraProperties = (childProperties: Record<string, any>) => {
  if (childProperties.numVariantsFiltered !== null) {
    // eslint-disable-next-line no-param-reassign
    delete childProperties.numVariantsFiltered;
  }

  if (childProperties.swatchesProps) {
    // eslint-disable-next-line no-param-reassign
    delete childProperties.swatchesProps;
  }
};

export const removeColorSwatches = (data: Record<string, any>) => {
  const childProducts = data?.productCategoryFacetedSearch?.productCategory.childProducts;
  childProducts?.forEach(childProduct => removeExtraProperties(childProduct));
};
